module.exports = __webpack_public_path__ + "img/qrcode.5201ab51.png";